import API from "../AxiosClient";
import ErrorHelper from "../../helpers/ErrorHelper";
import TokenDAO from "../../DAO/TokenDAO";

export default class EmpresaService {

	static async empresa(empresaPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const empresaResponse = await API.get(`/empresa/${empresaPk}/`, {
				headers: {
					Authorization: token
				}
			});

			return empresaResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async empresas(params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const empresaResponse = await API.get(`/empresa/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return empresaResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async reativarEmpresa(empresaPk, empresa) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.patch(`/empresa/${empresaPk}/`, empresa, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async editarEmpresa(empresaPk, empresa) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.put(`/empresa/${empresaPk}/`, empresa, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async criarEmpresa(empresa) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.post(`/empresa/`, empresa, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async gerenciaveis(empresaPk, perfilPk, params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const gerenciaveisResponse = await API.get(`/empresa/${empresaPk}/perfil/${perfilPk}/gerenciaveis/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return gerenciaveisResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async enviarAnexo(empresaPk, anexoData, onProgress) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const anexoResponse = await API.post(`/empresa/${empresaPk}/anexo/`, anexoData, {
				headers: {
					Authorization: token
				},
				onUploadProgress: onProgress ? onProgress : () => {},
			});

			return anexoResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async excluirAnexo(empresaPk, anexoPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.delete(`/empresa/${empresaPk}/anexo/${anexoPk}/`, {
				headers: {
					Authorization: token
				},
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

}
